import React from "react";
import { FiCheck } from "react-icons/fi";
import { cx, payoutUi } from "./payoutDesignSystem";

type PayoutFlowStepsProps = {
  steps: string[];
  activeStep: number;
  framed?: boolean;
  className?: string;
};

function PayoutFlowSteps({
  steps,
  activeStep,
  framed = true,
  className,
}: PayoutFlowStepsProps) {
  return (
    <div className={cx(framed ? payoutUi.stepper.shell : payoutUi.stepper.inlineShell, className)}>
      <div className={framed ? payoutUi.stepper.list : payoutUi.stepper.inlineShell}>
        {steps.map((label, index) => {
          const stepNumber = index + 1;
          const active = stepNumber === activeStep;
          const complete = stepNumber < activeStep;

          return (
            <React.Fragment key={label}>
              <div className={payoutUi.stepper.item}>
                <span
                  className={cx(
                    payoutUi.stepper.circle,
                    active || complete
                      ? payoutUi.stepper.circleActive
                      : payoutUi.stepper.circleIdle,
                  )}
                >
                  {complete ? <FiCheck /> : stepNumber}
                </span>
                <span
                  className={cx(
                    payoutUi.stepper.label,
                    active ? payoutUi.stepper.labelActive : payoutUi.stepper.labelIdle,
                  )}
                >
                  {label}
                </span>
              </div>
              {stepNumber < steps.length && (
                <span className={payoutUi.stepper.divider} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default PayoutFlowSteps;
